import * as React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import Dashboard from '../Dashboard';
import Login from '../authentication/Login';
import Register from '../authentication/Register';
import CodeConfirmation from '../authentication/CodeConfirmation';
import CodeExpired from '../authentication/CodeExpired';
import ResetPassword from '../authentication/ResetPassword';
import ResetPasswordCodeExpired from '../authentication/ResetPasswordCodeExpired';
import SignInRedirect from '../authentication/SignInRedirect';
import EnterDomain from '../EnterDomain';
import EditDomain from '../RenameDomain';
import Profile from '../profile/Profile';
import Billing from '../billing/Billing';
import { FilespaceCreationWizard } from '../wizard/FilespaceCreationWizard';
import BillingDetails from '../billing/details/BillingDetails';
import { productType, RETURN_ROUTE_PARAMETER_NAME } from '../../utils/constants';
import { AdminDashboard } from '../../../backoffice/components/Dashboard';
import { AdminRoute } from '../../../backoffice/components/root/Route';
import { Login as BackOfficeLogin } from '../../../backoffice/components/authentication/Login';
import { FilespaceRenameWizard } from '../wizard/FilespaceRenameWizard';

if (process.env.REACT_APP_PRODUCT === 'webportal') {
  require('bootstrap/dist/css/bootstrap.min.css');
  require('src/webportal/theme/css/bootstrap.min.css');
  require('src/webportal/theme/css/bootstrap-reboot.min.css');
  require('src/webportal/theme/css/bootstrap-grid.min.css');
  require('src/webportal/theme/css/main.css');
  require('src/webportal/theme/css/fonts.css');
  require('src/webportal/theme/css/vars.css');
} else {
  require('src/backoffice/theme/less/backoffice.css');
}

enum PageRoutes {
    Dashboard = '/dashboard',
    Billing = '/billing',
    Login = '/login',
    CodeConfirmation = '/codeConfirmation',
    Register = '/register',
    CodeExpired = '/codeExpired',
    ResetCodeExpired = '/resetCodeExpired',
    EnterDomain = '/enterDomain',
    CreateFilespace = '/dashboard/createFilespace',
    RenameFilespace = '/dashboard/renameFilespace',
    ResetPassword = '/resetPassword',
    BillingDetails = '/billingdetails',
    EditDomain = '/editDomain',
    Profile = '/profile',
    Redirect = '/redirect',
    BackOfficeDashboard = '/backoffice/dashboard',
    PasswordStep = '/password'
}

export { PageRoutes };

class Routes extends React.Component {
    render() {
        let editDomainPath = PageRoutes.EditDomain + '/:' + RETURN_ROUTE_PARAMETER_NAME;
        if (productType === 'webportal') {
            return (
                <Switch>
                    <PublicRoute path={PageRoutes.CodeConfirmation} component={CodeConfirmation}/>
                    <PublicRoute path={PageRoutes.Register} component={Register}/>
                    <PublicRoute path={PageRoutes.Login} component={Login}/>
                    <PublicRoute path={PageRoutes.CodeExpired} component={CodeExpired}/>
                    <PublicRoute path={PageRoutes.ResetPassword} component={ResetPassword}/>
                    <PublicRoute path={PageRoutes.ResetCodeExpired} component={ResetPasswordCodeExpired}/>
                    <PublicRoute path={PageRoutes.Redirect} component={SignInRedirect}/>
                    <PublicRoute path={PageRoutes.PasswordStep} component={Register}/>
                    <PrivateRoute path={PageRoutes.EnterDomain} component={EnterDomain}/>
                    <PrivateRoute path={editDomainPath} component={EditDomain}/>
                    <PrivateRoute path={PageRoutes.Profile} component={Profile}/>
                    <PrivateRoute path={PageRoutes.Dashboard} exact={true} component={Dashboard}/>
                    <PrivateRoute path={PageRoutes.CreateFilespace} component={FilespaceCreationWizard}/>
                    <PrivateRoute path={PageRoutes.RenameFilespace} component={FilespaceRenameWizard}/>
                    <PrivateRoute path={PageRoutes.Billing} component={Billing}/>
                    <PrivateRoute path={PageRoutes.BillingDetails} component={BillingDetails}/>
                    <Redirect to={PageRoutes.Dashboard}/>
                </Switch>
            );
        } else {
            return (
                <Switch>
                    <AdminRoute path={PageRoutes.Login} component={BackOfficeLogin}/>
                    <AdminRoute path={PageRoutes.Redirect} component={SignInRedirect}/>
                    <AdminRoute path={PageRoutes.BackOfficeDashboard} component={AdminDashboard}/>
                    <Redirect to={PageRoutes.BackOfficeDashboard}/>
                </Switch>
            );
        }
    }
}

export default Routes as any;



// WEBPACK FOOTER //
// ./src/webportal/components/root/Routes.tsx